import React from 'react';
import PropTypes from 'prop-types';

import PersonImg from 'inside-out/images/medicare/person-1.png';

import {
	innerWrapperStyle,
	wrapperStyle,
	attendStyle,
	titleStyle,
	attendTitleStyle,
	textStyle,
} from 'inside-out/page-styles/medicare';

import {
	contentSection,
} from 'inside-out/global-styles';

const MedicareForMeStep2Page = () => (
  <div className={wrapperStyle}>
    <section className={contentSection('#fff')}>
      <div className={attendStyle}>
        <div>
          <h1 className={attendTitleStyle}>Attend Sessions 1-10</h1>
          <div className={textStyle}>
            <p>Your eating disorders treatment plan (EDP) will initially provide access to up to 10 psychological sessions. For dietetic sessions you will get access from the outset to 20 sessions over a twelve month period. These have been made available from the beginning of your treatment plan, so if needed, you can have intensive dietetic appointments to aid with nutritional rehabilitation and refeeding early on, or you can space the 20 appointments across the 12 months. Discuss the best treatment approach for you with your dietitian.</p>

            <p>TIP If you and your psychologist and/or medical practitioner think that you are likely to need, and be eligible, for more than 20 psychological treatment sessions, then it is a good idea to make a booking for the mandated review with a psychiatrist or paediatrician in advance.  This review can be done at any point throughout the initial 20 session treatment course.</p>
	    <p>The specialist doctor report and recommendations must be sent to the GP before you can access sessions 20 - 40. Waitlists can be long so book in advance. These mandated reviews can be done by telehealth when eligible. Discuss with your GP.</p>
          </div>
        </div>
        <img src={ PersonImg } alt="" />
      </div>
    </section>
  </div>
);

export { MedicareForMeStep2Page }



// WEBPACK FOOTER //
// ./src/components/medicare/for-me/step-2.js